import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=5194bdd7&scoped=true&"
import script from "./posts.ts?vue&type=script&lang=ts&"
export * from "./posts.ts?vue&type=script&lang=ts&"
import style0 from "./posts.scss?vue&type=style&index=0&id=5194bdd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194bdd7",
  null
  
)

export default component.exports